export function hasComingSoon(productGroup, productId) {
  if (productGroup && productGroup.shopifyProducts) {
    const hasComingSoon = productGroup.shopifyProducts.filter(
      ({ productReferenceV2 }) =>
        productReferenceV2.id === productId &&
        productReferenceV2.tags &&
        productReferenceV2.tags.find((tag) => tag === "coming-soon")
    );

    if (hasComingSoon.length > 0) {
      return true;
    }
  }
  return false;
}
